import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ChangePassword, ForgotPassword, Login } from '../models/loginModel';
import { LoggedInUserInfo } from '../models/loggedInUserModel';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';


@Injectable({ providedIn: 'root' })
export class LoginService {


  httpOptions = {
    headers: new HttpHeaders({
      'Accept': 'application/json',
      'Content-Type': 'text/plain',
    })
  };

  constructor(
    private http: HttpClient, private authService: AuthService) { }

  loginUser(loginParams?: Login): Observable<any> {
    return this.http.post(environment.loginURL.replace('#hostname#', this.authService.loginHostName$.value), loginParams, this.httpOptions);
  }

  forgotPassword(forgotPasswordParams?: ForgotPassword): Observable<any> {
    return this.http.put(environment.loginURL.replace('#hostname#', this.authService.loginHostName$.value), forgotPasswordParams, this.httpOptions);
  }

  resetPassword(resetPasswordParams?: ForgotPassword): Observable<any> {
    return this.http.put(environment.loginURL.replace('#hostname#', this.authService.loginHostName$.value), resetPasswordParams, this.httpOptions);
  }

  confirmForgotPassword(confirmForgotPasswordParams?: ForgotPassword): Observable<any> {
    return this.http.put(environment.loginURL.replace('#hostname#', this.authService.loginHostName$.value), confirmForgotPasswordParams, this.httpOptions);
  }

  changePassword(changePasswordParams?: ChangePassword): Observable<any> {
    return this.http.patch(environment.loginURL.replace('#hostname#', this.authService.loginHostName$.value), changePasswordParams, this.httpOptions);
  }

}
